import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DataTableBase from "../../common/Datatable";
import moment from "moment";
import makeRequest from "../../../../api";
import { trainerService, userService } from "../../../../api/services";
import { toast } from "react-toastify";
import { FaRegCopy } from "react-icons/fa";

const PrescriptionsListing = () => {
  const params = useParams();
  const userId = params.userId;

  const [prescriptionsList, setPrescriptionsList] = useState<any>([]);
  const [userDetails, setUserDetails] = useState<any>(null);

  const fetchPrescriptions = async () => {
    try {
      const res = await makeRequest(
        trainerService.getUserPrescriptionList(userId)
      );
      const response = res?.data?.body?.prescriptionsList?.sort(
        (a: any, b: any) => +b?.createdAtEpoch - +a?.createdAtEpoch
      );
      setPrescriptionsList([...response]);
    } catch (error: any) {
      toast.error("Error fetching prescriptions list!");
    }
  };

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const getUserData = async () => {
    try {
      const res = await makeRequest(userService.getUserDetails(userId));
      setUserDetails({ ...res?.data?.userDto });
    } catch (error: any) {
      toast.error("Error fetching user details!");
    }
  };

  useEffect(() => {
    if (userId) {
      getUserData();
    }
  }, [userId]);

  const columns = [
    {
      name: "Prescription title",
      selector: (row: any) => row.title,
      cell: (row: any) => {
        return (
          <div>
            {row.title} with {row?.doctorDetails?.name}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Prescription url",
      selector: (row: any) => row?.fileDetails?.s3URL,
      cell: (row: any) => {
        return (
          <Link to={row?.fileDetails?.s3URL} target="_blank">
            View prescription
          </Link>
        );
      },
    },
    {
      name: "Prescription date",
      selector: (row: any) => row.createdAtEpoch,
      cell: (row: any) =>
        moment(row.createdAtEpoch).format("DD MMM YYYY, hh:mm A"),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row: any) => row,
      cell: (row: any) => {
        return (
          <Link
            to={`add?issueType=${row?.issueType}&createdAt=${row.createdAtEpoch}`}
            className="d-flex align-items-center gap-1"
          >
            Duplicate <FaRegCopy />
          </Link>
        );
      },
    },
  ];

  return (
    <div className="container-lg">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-3">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/users/${userId}/reports`}>Reports</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Prescriptions
          </li>
        </ol>
      </nav>
      <div className="d-flex align-items-center justify-content-between mb-3">
        {userDetails?.fullName && (
          <h6 className="fw-700 fs-24 mb-0">
            {userDetails?.fullName}'s prescriptions
          </h6>
        )}
        <Link to="add" className="btn btn-sm btn-outline-success">
          Add prescription
        </Link>
      </div>
      <DataTableBase columns={columns} data={prescriptionsList} />
    </div>
  );
};

export default PrescriptionsListing;
